import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Image from '../Image/Image';

import { mediaMin } from '@styles/sizes';
import { GOTHAM_MEDIUM } from '../../styles/typography';
import { Tv } from '../../components/Icon/Tv';
import { Pin } from '../../components/Icon/Pin';
import { Film } from '../../components/Icon/Film';

const StyledProject = styled.div`
  ${mediaMin.tablet`
    padding-bottom: ${props => props.special && '80px'};
  `}
  margin-bottom: 80px;
`;

const StyledImage = styled(Image)`
  margin-bottom: 16px;
`;

const StyledTitle = styled.h4`
  font-family: ${GOTHAM_MEDIUM};
  font-size: 21px;
  margin-bottom: 4px;
`;

// const SpecialProject = styled.div`
//   ${mediaMin.tablet`
//     position: absolute;
//     background: #F1F5F2;
//     padding: 40px;
//     max-width: 60%;
//     bottom: 80px;
//     right: 0;
//   `}
// `;

const StyledList = styled.ul`
  list-style: none;
  margin-bottom: 16px;
  font-size: 14px;
  li {
    margin-bottom: 4px;
    display: flex;
    align-items: center;
  }
`;

const StyledIcon = styled.span`
  height: 16px;
  display: inline-block;
`;

const Project = ({ src, project, special, className }) => {
  const { name, channel, producer, location } = project;

  function ProjectDetails() {
    return (
      <React.Fragment>
        <StyledTitle>{name}</StyledTitle>
        <StyledList>
          {channel && (
            <li>
              <StyledIcon>
                <Tv />
              </StyledIcon>{' '}
              {channel}
            </li>
          )}
          {producer && (
            <li>
              <StyledIcon>
                <Film />
              </StyledIcon>{' '}
              {producer}
            </li>
          )}
          {location && (
            <li>
              <StyledIcon>
                <Pin />
              </StyledIcon>{' '}
              {location}
            </li>
          )}
        </StyledList>
      </React.Fragment>
    );
  }

  // function renderProjectInfo() {
  //   if (special) {
  //     return (
  //       <SpecialProject>
  //         <ProjectDetails />
  //       </SpecialProject>
  //     );
  //   }
  //   return <ProjectDetails />;
  // }
  return (
    <StyledProject special={special} className={className}>
      <StyledImage src={src} />
      <ProjectDetails />
    </StyledProject>
  );
};

Project.propTypes = {
  project: PropTypes.object.isRequired,
};

export default Project;
